import { onMounted, nextTick } from 'vue'
import { usePrint } from '../hook/use-print'
import { Loading } from 'element-ui'
import { pgMessageBox } from '../../message-box/index'
import { http } from '../../../utils/index'

export default {
  props: {
    // 为true 继续进行打印 为false 则直接跳出组件继续向下进行
    beforeHandlePrint: {
      type: Boolean,
      default: true,
    },
    orderData: [Object, Array],
    extendData: Object,
    savePrintCount: String,
    savePrintCountParams: Object,
    orderDataId: {
      type: String,
      default: 'id',
    },
    printTemplate: Object,
    printTemplateUrl: {
      type: String,
      default: 'rest/ezcomp/report/templatePrefer',
    },
    printTemplateParam: Object,
    printTemplateMethod: {
      type: String,
      default: 'get',
    },
    //发生错误时是否抛出on-cancel事件，为false时统一抛出on-ok
    cancel: {
      type: Boolean,
      default: true,
    },
    //调用打印时的前置钩子，接收参数为 {printTemplate, orderData, extendData}
    //printTemplate为选择的打印模板详情数据，可在打印模板中配置 printTemplate.dataset.printBefore 来对该打印模板打印前特俗逻辑处理
    //该函数支持异步，如有返回值则会覆盖props.orderData
    printBefore: Function,
  },
  emits: ['on-ok', 'closed'],
  setup(props, { emit }) {
    const { print } = usePrint({
      orderData: props.orderData,
      extendData: props.extendData,
      savePrintCount: props.savePrintCount,
      orderDataId: props.orderDataId,
      savePrintCountParams: props.savePrintCountParams,
      printBefore: props.printBefore,
    })

    onMounted(async () => {
      if (!props.beforeHandlePrint) {
        nextTick(() => {
          emit('on-ok')
          emit('closed')
        })
        return
      }
      if (
        !props.orderData ||
        props.orderData?.length === 0 ||
        (!props.printTemplate && !props.printTemplateUrl)
      ) {
        console.error('未配置打印数据')
        nextTick(() => {
          emit(props.cancel ? 'on-cancel' : 'on-ok')
          emit('closed')
        })
        return
      }
      let loadingInstance1 = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
      const printTemplateData =
        props.printTemplate ??
        (await http[props.printTemplateMethod](props.printTemplateUrl, props.printTemplateParam, {
          errorTip: null,
        }).then(([res]) => res?.data))
      if (!printTemplateData) {
        await new Promise((resolve) => {
          pgMessageBox({
            message:
              '请先通过”自定义打印”按钮设置一个默认打印模板后再操作。如有疑问，请联系管理员!',
            beforeClose(onClose) {
              onClose()
              resolve()
            },
          })
        })
        emit(props.cancel ? 'on-cancel' : 'on-ok')
        emit('closed')
        loadingInstance1.close()
        return
      }
      const res = await print(printTemplateData)?.catch((error) => ({ type: 'error', error }))
      loadingInstance1.close()
      if (res?.type !== 'error') {
        emit('on-ok')
      } else {
        emit(props.cancel ? 'on-cancel' : 'on-ok')
      }
      emit('closed')
    })
    return () => null
  },
}
